import React from "react";
// import Hotels from "./Hospitality/Hotels";
import SnapshotDataCards from "./SnapshotDataCards";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import NavigationMenu from "./NavigationMenu";

export default function RealEstate() {
  return (
    <Box>
      <Card>
        <CardContent>
          <SnapshotDataCards />
        </CardContent>
      </Card>

      <NavigationMenu />

      {/* <LandPrices /> */}
      {/* <Hotels /> */}
    </Box>
  );
}
